// links to backend

// links to api on production
const GET_USER_DATA = "https://www.api.dsgaff.com/api/v1/image/getUser/";
const CHECK_EMAIL_URL = "https://www.api.dsgaff.com/api/v1/check/check/";

const GET_IMAGES_URL = "https://www.api.dsgaff.com/api/v1/image/";
const GET_ALL_CHARTS = "https://www.api.dsgaff.com/api/v1/image/getCharts/";

// links to api local
// const GET_USER_DATA = "http://localhost:8000/api/v1/image/getUser/"; //podczas odświeżania strony pobiera user.subsribe i filtruje dane
// const CHECK_EMAIL_URL = "http://localhost:8000/api/v1/check/check/"; //używanie przy logowaniu i tworzenie nowego użytkownika, jeśli nie istnieje w naszej db

// const GET_IMAGES_URL = "http://localhost:8000/api/v1/image/"; //nie użwane
// const GET_ALL_CHARTS = "http://localhost:8000/api/v1/image/getCharts/";


export {GET_ALL_CHARTS, GET_IMAGES_URL, GET_USER_DATA, CHECK_EMAIL_URL}